module.exports = __webpack_public_path__ + "static/img/u189.4a1b544.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u189.jpg
// module id = hzud
// module chunks = 0